import chatMixin from '@/mixins/chat';
function extend(app, mixin) {
  if (!app.mixins) {
    app.mixins = [];
  }
  app.mixins.push(mixin);
}

// eslint-disable-next-line space-before-function-paren
export default async function ({ app }) {
  await extend(app, {
    mixins: [chatMixin],
    mounted() {
      window.addEventListener('CookiebotOnLoad', this.cookiebotOnLoad);
      window.addEventListener('CookiebotOnConsentReady', this.cookiebotOnConsentReady);
    },
    destroyed() {
      window.removeEventListener('CookiebotOnLoad', this.cookieBotLoaded, false);
      window.removeEventListener('CookiebotOnConsentReady', this.cookiebotOnConsentReady);
    },
    methods: {
      cookiebotOnConsentReady() {
        const consents = window.Cookiebot.consent;
        if (window?.clarity) {
          window.clarity('consent', consents.statistics);
        }
        if (consents.marketing && consents.preferences && consents.statistics) {
          this.loadZohoChat(false);
        } else {
          this.hideChat();
        }
      },
      cookiebotOnLoad() {
        const consents = window.Cookiebot.consent;
        if (consents.marketing && consents.preferences && consents.statistics) {
          this.loadZohoChat(false);
        }
      },
    },
  });
}
